"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var cardChallengeVgsTokenizerQuery = graphql_tag_1["default"](templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query cardChallengeVgsTokenizer($cardData: CardChallengeVgsInput!) {\n    cardChallengeVgsTokenizer(cardData: $cardData) {\n      addressLine1\n      cvv\n      expMonth\n      expYear\n      number\n      zip\n    }\n  }\n"], ["\n  query cardChallengeVgsTokenizer($cardData: CardChallengeVgsInput!) {\n    cardChallengeVgsTokenizer(cardData: $cardData) {\n      addressLine1\n      cvv\n      expMonth\n      expYear\n      number\n      zip\n    }\n  }\n"])));
exports["default"] = cardChallengeVgsTokenizerQuery;
var templateObject_1;
